import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class Win32_BIOSInfo extends InfoSet {

    public Caption: string;
    public get HasCaption(): boolean {
        return !!this.Caption;
    }

    public Description: string;
    public get HasDescription(): boolean {
        return !!this.Description;
    }

    public Manufacturer: string;
    public get HasManufacturer(): boolean {
        return !!this.Manufacturer;
    }

    public Name: string;
    public get HasName(): boolean {
        return !!this.Name;
    }

    public ReleaseDate: number;
    public get HasReleaseDate(): boolean {
        return !!this.ReleaseDate;
    }

    public SerialNumber: string;
    public get HasSerialNumber(): boolean {
        return !!this.SerialNumber;
    }

    public Verion: string;
    public get HasVersion(): boolean {
        return !!this.Verion;
    }

    constructor(device: Device) {
        super(device);
        this.Init();
    }

    private Init() {
        this.Caption = "";
        this.Description = "";
        this.Manufacturer = "";
    }

    public Write(obj: any, context: any): void {
        obj.w32_comp_sys_info = {};
        obj = obj.w32_comp_sys_info;

        if (this.HasCaption)
            obj.caption = this.Caption;

        if (this.HasDescription)
            obj.description = this.Description;

        if (this.HasManufacturer)
            obj.manufacturer = this.Manufacturer;

        if (this.HasName)
            obj.name = this.Name;

        if (this.HasReleaseDate)
            obj.release_date = this.ReleaseDate;

        if (this.HasSerialNumber)
            obj.serial_number = this.SerialNumber;

        if (this.HasVersion)
            obj.version = this.HasVersion;
    }

    public Read(obj: any, context: any): void {
        if (!obj.w32_bios_info)
            throw new Error();
        obj = obj.w32_bios_info;

        if (obj.caption !== undefined)
            this.Caption = obj.caption;

        if (obj.description !== undefined)
            this.Description = obj.description;

        if (obj.manufacturer !== undefined)
            this.Manufacturer = obj.manufacturer;

        if (obj.name !== undefined)
            this.Name = obj.name;

        if (obj.release_date !== undefined)
            this.ReleaseDate = obj.release_date;

        if (obj.serial_number !== undefined)
            this.SerialNumber = obj.serial_number;

        if (obj.version !== undefined)
            this.Verion = obj.version;
     
    }
}
